export const SOCKET_URL =
  process.env.VITE_API_ENV === 'dev'
    ? `wss://test.synf.lawincodes.net/v4/public/ws`
    : `wss://base-api.synfutures.com/v4/public/ws`;

export const GELATO_API = 'https://api.gelato.digital';

export const AIP_DOMAIN =
  process.env.VITE_API_ENV === 'dev' ? 'https://test.synf.lawincodes.net' : 'https://base-api.synfutures.com';

export const SYN_API_URLS = {
  MARKET: {
    PAIR_INFO: '/v4/public/market/marketPairInfo',
    PAIR_LIST: '/v4/public/market/marketList',
  },
  FUTURES: {
    INSTRUMENT: '/v4/public/market/instrument',
    INSTRUMENT_INQUIRE: '/v4/public/market/inquire',
    INSTRUMENT_INQUIRE_BY_TICK: '/v4/public/market/inquireByTick',
    INSTRUMENT_INQUIRE_BY_NOTIONAL: '/v4/public/market/inquireByNotional',
    ORDER_BOOK: '/v4/public/market/orderBook',
    DEPTH_CHARTS: '/v4/public/market/depth',
    FUNDING_CHARTS: '/v4/public/market/fundingRate',
    KLINE_CHARTS: '/v4/public/market/kline',
    LIQUIDITY_CHARTS: '/v4/public/market/liquidityData',
  },
  PORTFOLIO: {
    USER_VOLUME: `/v4/public/market/user/volumes`,
    USER_PORTFOLIO: '/v4/public/market/portfolio',
    USER_GATE_VALUE: '/v4/public/market/user/gateValue',
    USER_ALL_TOKEN_BALANCE: '/v4/public/token/allBalance',
  },
  HISTORY: {
    TRADE: '/v4/public/history/trade',
    ORDER: '/v4/public/history/order',
    ACCOUNT: '/v4/public/history/fundFlow',
    FUNDING: '/v4/public/history/funding',
    LQUIDITY: '/v4/public/history/liquidity',
    TRANSFER: '/v4/public/history/transfer',
  },
  GLOBAL: {
    TOKEN_PRICE: `/v4/public/token/tokensWithAddress`,
  },
  COMMON: {
    CHECK_IP: '/v4/public/checkIp',
    DAPP_CONFIG: `/v4/public/common/dapp/config`,
  },
  OTHER: {
    ABC_FAUCET_SEND_TX: '/v4/public/abcFaucet/sendTx',
    SHARE_TWITTER: '/v4/public/share/twitter',
    GET_TWITTER_IMG_LINK: '/v4/public/share/twitter/link',
  },
  ONE_CT: {
    GELATO_LOGIN: '/v3/public/appchain/auth/login',
    GELATO_SUBAccount: '/v3/public/appchain/gelato/subaccount',
    GELATO_OPERATION: '/v3/public/appchain/gelato/operation',
    TX_LOGIN: '/v4/public/frontend-tx/login',
    TX_SUBMIT: '/v4/public/frontend-tx/submit',
  },
  VAULT: {
    INFOS: '/v3/public/vault',
    SUMMARY: '/v3/public/vault/summary',
  },
} as const;
